import { ClaimDocument } from './../../../interfaces/claim.interface';
import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    ViewChild,
    ViewChildren
} from '@angular/core'
import {ApiService, UserInfo} from "../../../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ComponentsModule } from '@components/components.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { LoadingComponent } from '@components/loading/loading.component';
import { ButtonComponent } from '@components/button/button.component';
import { NewClaimComponent } from '../new-claim/new-claim.component';
import { InputComponent } from '@components/input/input.component';
import { ClaimCardComponent } from '../claim-card/claim-card.component';
import { BadgeStatusComponent } from '@components/badge-status/badge-status.component';
import { LoadingService } from 'app/services/loading.service';
import { Claim, ClaimComments } from 'app/interfaces/claim.interface';
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component';
import { ClaimService } from 'app/services/claim.service';
import { ClaimActions } from 'app/interfaces/claim-actions';
import { ClaimRequestDocument } from '../../../interfaces/claim-request-required-documents'
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component'
import { EnglishTranslateService } from '../../../services/english-translate.service'

@Component({
    selector: 'app-claim-summary',
    templateUrl: './claim-summary.component.html',
    styleUrl: './claim-summary.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        ComponentsModule,
        TranslateModule,
        LoadingComponent,
        ButtonComponent,
        NgOptimizedImage,
        NewClaimComponent,
        InputComponent,
        ClaimCardComponent,
        BadgeStatusComponent,
        CosentinoSvgComponent,
        ConfirmModalComponent
    ]
})
export class ClaimSummaryComponent implements OnInit {
    loading: boolean = true
    @Input('claim')
    claim: Claim

    @Input('claimId')
    claimIdToFetch: string

    @Input('readOnly')
    readOnly: boolean = false

    claimComments: ClaimComments[]
    claimDocuments: ClaimDocument[]
    @Input('currentTab') currentTab: string = 'SUMMARY'
    conversationArea = { current: null as HTMLDivElement | null }
    notes: string = ''
    // projectListResponse: ClaimListResponse
    userInfo: UserInfo
    id: string

    firstLoading = true
    @Input() comment: string = ''


    @ViewChild('claimDocumentInput') claimDocumentInput: ElementRef<HTMLInputElement>
    acceptedDocuments = ['image/png', 'image/jpeg', 'application/pdf']
    acceptedDocumentsString = this.acceptedDocuments.join(',')
    maxDocumentSize = 4 * 1024 * 1024

    isErrorModalVisible: boolean
    errorMessage: string;

    @Output() onTabSwitch = new EventEmitter<string>()

    constructor(
        private api: ApiService,
        private router: Router,
        private route: ActivatedRoute,
        private loadingService: LoadingService,
        private claimService: ClaimService,
        private translate: TranslateService,
        private engTranslate: EnglishTranslateService
    ) {}

    ngOnInit(): void {
        if (!this.claim) {
            //this can come from input param
            this.api.userInfo.subscribe((userInfo) => {
                this.userInfo = userInfo
            })
            this.route.params.subscribe((params) => {
                if(this.claimIdToFetch) {
                    this.id = this.claimIdToFetch
                }
                else {
                    this.id = params['id'] || params['claimId']
                }
                this.fetchClaim()
                this.fetchClaimComments()
            })
        } else {
            this.id = this.claim.id
            this.fetchClaimComments()
        }
    }
    updateNotes() {
        console.log(this.notes)
        if (this.notes.length > 0) {
            this.api.updateClaimNotes(this.claim.id, this.notes).subscribe((claim) => {
                // this.claim = claim
            })
        }
    }
    fetchClaim() {
        this.loadingService.show()
        this.api.getClaim(this.id).subscribe((claim) => {
            this.claim = claim
            this.notes = claim.personalNote || ''
            this.loadingService.hide()
        })
    }
    fetchClaimComments() {
        // this.loadingService.show()
        this.api.getClaimDocuments(this.id).subscribe((claimDocuments) => {
            this.claimDocuments = claimDocuments
        })
        this.api.getClaimComments(this.id).subscribe((claimComments) => {
            this.claimComments = claimComments
            // this.loadingService.hide()
            // this.claimComments = [
            //     {
            //         id: '1',
            //         commentBody: 'hola, como estas',
            //         createdDate: '2026-07-06',
            //         createdBy: 'Pepe',
            //     },
            //     {
            //         id: '2',
            //         commentBody: 'hola, aqui estamos todo agustico con el aire acondicionado puesto',
            //         createdDate: '2026-07-06',
            //         createdBy: 'Pepe',
            //     },
            //     {
            //         id: '3',
            //         commentBody: 'Pues yo pasando calorrrr',
            //         createdDate: '2026-07-06',
            //         createdBy: 'Pepe',
            //     },
            //     {
            //         id: '4',
            //         commentBody: 'Pues date un baño en la piscina',
            //         createdDate: '2026-07-07',
            //         createdBy: 'Salas Design',
            //     },
            //     {
            //         id: '5',
            //         commentBody: 'y ya te pago el material',
            //         createdDate: '2026-07-07',
            //         createdBy: 'Salas Design',
            //     },
            //     {
            //         id: '2',
            //         commentBody: 'hola, aqui estamos todo agustico con el aire acondicionado puesto',
            //         createdDate: '2026-07-06',
            //         createdBy: 'Pepe',
            //     },
            //     {
            //         id: '3',
            //         commentBody: 'Pues yo pasando calorrrr',
            //         createdDate: '2026-07-06',
            //         createdBy: 'Pepe',
            //     },
            //     {
            //         id: '4',
            //         commentBody: 'Pues date un baño en la piscina',
            //         createdDate: '2026-07-07',
            //         createdBy: 'Salas Design',
            //     },
            //     {
            //         id: '5',
            //         commentBody: 'y ya te pago el material',
            //         createdDate: '2026-07-07',
            //         createdBy: 'Salas Design',
            //     },
            //     {
            //         id: '2',
            //         commentBody: 'hola, aqui estamos todo agustico con el aire acondicionado puesto',
            //         createdDate: '2026-07-06',
            //         createdBy: 'Pepe',
            //     },
            //     {
            //         id: '3',
            //         commentBody: 'Pues yo pasando calorrrr',
            //         createdDate: '2026-07-06',
            //         createdBy: 'Pepe',
            //     },
            //     {
            //         id: '4',
            //         commentBody: 'Pues date un baño en la piscina',
            //         createdDate: '2026-07-07',
            //         createdBy: 'Salas Design',
            //     },
            //     {
            //         id: '5',
            //         commentBody: 'y ya te pago el material',
            //         createdDate: '2026-07-07',
            //         createdBy: 'Salas Design',
            //     },
            // ]
            console.log(this.claimComments, 'comments')
            console.log(this.userInfo, 'weUserInfo')
        })
    }
    getClaimActions(claim: Claim): ClaimActions {
        return this.claimService.getClaimActions(claim)
    }
    setCurrentTab(tab: string) {
        this.currentTab = tab
        this.onTabSwitch.emit(tab)
        if (tab == 'COMMENTS') this.scrollIntoView()
    }
    sendMessage() {
        this.api.sendClaimComment(this.claim.id, this.comment).subscribe((claim) => {
            this.comment = ''
            this.fetchClaimComments()
        })
    }
    shouldShowDate(index: number): boolean {
        if (index === 0) {
            return true
        }

        const current = this.claimComments[index]
        const previous = this.claimComments[index - 1]
        if (!current?.createdDate || !previous?.createdDate) {
            return true // Mostrar la fecha si alguna de las fechas es nula
        }
        // Compara solo la parte de la fecha (no la hora)
        const currentDate = new Date(current.createdDate).toDateString()
        const previousDate = new Date(previous.createdDate).toDateString()

        return currentDate !== previousDate
    }
    scrollIntoView = () => {
        const el = this.conversationArea.current
        el && el.scrollTo(0, el.scrollHeight)
    }
    getDocument = (caseId: string, documentId: string, title: string, extension: string) => {
        this.api.downloadClaimDocument(caseId, documentId).subscribe((blob) => {
            const blobUrl = window.URL.createObjectURL(blob)

            const a = document.createElement('a')
            a.href = blobUrl
            a.download = title
            if(title.substring(title.lastIndexOf('.') + 1) !== extension) {
                a.download += '.' + extension
            }

            a.click()

            // Limpieza
            window.URL.revokeObjectURL(blobUrl)
        })
    }
    downloadAllDocuments = (caseId: string) => {
        this.api.downloadAllClaimDocuments(caseId).subscribe((blob) => {
            const blobUrl = window.URL.createObjectURL(blob)

            const a = document.createElement('a')
            a.href = blobUrl
            a.download = caseId + '.zip'
            a.click()

            // Limpieza
            window.URL.revokeObjectURL(blobUrl)
        })
    }

    onOpenFileSelect() {
        const fileInput = this.claimDocumentInput
        if(fileInput) {
            fileInput.nativeElement.click()
        } else {
            console.log('No file input found')
        }

        console.log('Clicked on file drop area')
    }


    onFileSelected($event: any) {
        const files = $event.target.files
        const document: ClaimRequestDocument = {
            id: 'additional_document',
            label: this.translate.instant('create-claim.documentation.additional_document'),
            englishLabel: this.engTranslate.instant('create-claim.documentation.additional_document'),
            isRequired: true,
            requiresChecked: [],
            requiresUnchecked: [],
        }

        Array.from(files).forEach((file: any) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                if (reader.result) {

                    // Check file type
                    let isDocumentTypeAccepted = false
                    for(let acceptedDocument of this.acceptedDocuments) {
                        if(file.type.match(acceptedDocument) || file.type === acceptedDocument) {
                            isDocumentTypeAccepted = true
                            break;
                        }
                    }
                    if(!isDocumentTypeAccepted) {
                        this.openErrorMessageModal(this.translate.instant('create-claim.documentation.invalid_file_type'))
                        this.clearHTMLInput()
                        return
                    }

                    // Check file size
                    if(file.size > this.maxDocumentSize) {
                        this.openErrorMessageModal(this.translate.instant('create-claim.documentation.file_too_large'))
                        this.clearHTMLInput()
                        return
                    }

                    this.api.uploadClaimDocument(this.claim.id, file, document.id, document.englishLabel, true).subscribe(res => {
                        document.document = res
                        this.clearHTMLInput()
                        this.fetchClaimComments()
                    })
                }
            }
        })
    }

    openErrorMessageModal(message: string) {
        this.isErrorModalVisible = true
        this.errorMessage = message
    }

    clearHTMLInput() {
        const fileInput = this.claimDocumentInput
        if(fileInput){
            fileInput.nativeElement.value = ''
        }
    }

    brandStringToImage(brand?: string | null){
        if(!brand){
            return;
        }
        switch (brand.toLowerCase()){
            case 'silestone':
                return 'assets/icons/brands/silestone-alt.svg';
            case 'dekton':
                return 'assets/icons/brands/dekton-alt.svg';
            case 'sensa':
                return 'assets/icons/brands/sensa-alt.svg';
            case 'scalea':
                return 'assets/icons/brands/scalea-alt.svg';
        }

        return;
    }

}
